import { Component, OnInit } from "@angular/core";
import {
  FormGroup,
  FormBuilder,
  FormControl,
  Validators,
} from "@angular/forms";
import { ApiService } from "src/app/services/api/api.service";
import { map } from "rxjs/operators";
import { MustMatch } from "../../shared/validators/confirmation-password.validator";
import { BehaviorSubject } from "rxjs";

@Component({
  selector: "app-change-password",
  templateUrl: "./change-password.component.html",
  styleUrls: ["./change-password.component.scss"],
})
export class ChangePasswordComponent implements OnInit {
  private currentPasswordInput = "password";
  private newPasswordInput = "password";
  private confirmNewPasswordInput = "password";

  public isComponentOpen = new BehaviorSubject(false);

  private changePasswordForm: FormGroup;
  constructor(
    private formBuilder: FormBuilder,
    private apiService: ApiService,
  ) {}

  ngOnInit() {
    this.changePasswordForm = this.formBuilder.group(
      {
        old_password: new FormControl("", [Validators.required]),
        password: new FormControl("", [Validators.required]),
        password_confirmation: new FormControl("", [Validators.required]),
      },
      {
        validator: MustMatch("password", "password_confirmation"),
      },
    );
  }

  onSubmit() {
    const requestData = new FormData();
    Object.keys(this.form.value).forEach((key) => {
      if (this.form.value[key]) {
        requestData.append(key, this.form.value[key]);
      }
    });
    requestData.append("_method", "patch");

    this.apiService
      .post("profile/update", requestData)
      .pipe(map((response: any) => response))
      .subscribe((response) => {
        if (response.result) {
          this.isComponentOpen.next(false);
        }
      });
  }

  isComponentClosed(ev: boolean): void {
    if (ev) {
      this.form.reset();

      this.form.get("old_password").setErrors(null);
      this.form.get("password").setErrors(null);
      this.form.get("password_confirmation").setErrors(null);
    }
  }

  changeCurrentPassowrdInputType() {
    this.currentPasswordInput === "password"
      ? (this.currentPasswordInput = "text")
      : (this.currentPasswordInput = "password");
  }

  changeNewPassowrdInputType() {
    this.newPasswordInput === "password"
      ? (this.newPasswordInput = "text")
      : (this.newPasswordInput = "password");
  }

  changeConfirmNewPassowrdInputType() {
    this.confirmNewPasswordInput === "password"
      ? (this.confirmNewPasswordInput = "text")
      : (this.confirmNewPasswordInput = "password");
  }

  get currentPasswordInputType() {
    return this.currentPasswordInput;
  }

  get newPasswordInputType() {
    return this.newPasswordInput;
  }

  get confirmNewPasswordInputType() {
    return this.confirmNewPasswordInput;
  }

  get form() {
    return this.changePasswordForm;
  }
}
